const GAUGE_SCALE = 10

export const getIntensityGauge = (
  intensityMeter?: string,
  intensityLabel?: string
) => {
  if (!intensityMeter) {
    return undefined
  }

  const value = parseInt(intensityMeter, 10)
  const gauge = {
    value,
    scale: GAUGE_SCALE,
    ...(intensityLabel && {
      label: intensityLabel
    })
  }

  return [gauge]
}
